import React, {useRef, useMemo} from 'react'
import PropTypes from 'prop-types'
import { Navigate } from 'react-big-calendar'
import EasyCalEvent from '../EasyCalEvent';
import { sort } from 'rrule/dist/esm/dateutil';

// const EVENTS_PER_PAGE = 9;
const DEFAULT_LENGTH = 30; // number of days in in range.

const EasyCalTiles = ({ //
  date,
  events,
  accessors,
  components,
  getters,
  onSelectEvent,
  onDoubleClickEvent,
  localizer,
  ...props
}) => {

  // Calculate range of dates to display 
  const range = useMemo(() => {
    const start = localizer.startOf(date, 'month');
    const end = localizer.add(start, DEFAULT_LENGTH, 'day');
    return localizer.range(start, end);
  }, [date, localizer]);

  // Filter events to include those within the range.
  const filteredEvents = useMemo(() => {
    return events.filter((event) => {
      const eventStart = accessors.start(event);
      const eventEnd   = accessors.end(event);
      return ( localizer.inRange(eventStart, range[0], range[range.length -1], 'date') );
    });
  }, [events, range, accessors, localizer]);

  const sortedEvents = useMemo(() => {
    return [...filteredEvents].sort((a, b) => +accessors.start(a) - +accessors.start(b));
  }, [filteredEvents, accessors]);

  const renderEventTile = (event) => {
    const {event: EasyCalEvent} = components;
    const title = accessors.title(event);
    const start = accessors.start(event);
    const end = accessors.end(event);
    const userProps = getters.eventProp(event, start, end, false);

    return (
      <div 
        key={event.id || title}  
        className='rbc-event-tile easycal-tile' 
        style={userProps.style}
        onClick={(e) => onSelectEvent && onSelectEvent(event, e)}
        onDoubleClick={(e) => onDoubleClickEvent && onDoubleClickEvent(event, e)}
      >
        {EasyCalEvent ? <EasyCalEvent event={event} title={title} view="tiles"/> : title}
      </div>
    );
  }

  return (
    <div className="rbc-event-tiles-view easycal-tiles-view">
      {sortedEvents.length > 0 ? (
        sortedEvents.map(renderEventTile)
        ) : (<div className='rbc-no-events easycal-noevents'>No events found.</div>
        )}
    </div>
  );
};

EasyCalTiles.propTypes = {
  events: PropTypes.array.isRequired,
  accessors: PropTypes.object.isRequired,
  components: PropTypes.object.isRequired,
  date: PropTypes.instanceOf(Date),
  length: PropTypes.number.isRequired,
  localizer: PropTypes.object.isRequired,
  getters: PropTypes.object.isRequired,
  onSelectEvent: PropTypes.func,
  onDoubleClickEvent: PropTypes.func,
};

EasyCalTiles.title = (start, { length = 30, localizer }) => {
  const end = localizer.add(start, length, 'day')
  return localizer.format({ start, end }, 'month')
}

EasyCalTiles.range = (start, { length = 30, localizer }) => {
  const end = localizer.add(start, length, 'day')
  return { start, end }
}

EasyCalTiles.navigate = (
  date,
  action,
  { length = 30, localizer }
) => {
  switch (action) {
    case Navigate.PREVIOUS:
      return localizer.add(date, -length, 'day')

    case Navigate.NEXT:
      return localizer.add(date, length, 'day')

    default:
      return date
  }
}

export default EasyCalTiles;